/* Catalog (items, categories, units, par levels, suppliers, purchase history,
 * price movements) and Recipes / Menu engineering. Shared vocabulary lives in
 * common.js — only feature-specific strings here. */
const catalog = {
  // --- Catalog page ---------------------------------------------------------
  'Your item master — products, units, categories and supplier pricing.': 'Master barang Anda — produk, satuan, kategori, dan harga pemasok.',
  'Catalog sections': 'Bagian katalog',
  'Price movements': 'Pergerakan harga',
  'Units': 'Satuan',
  'New item': 'Barang baru',
  'Search by name, SKU or barcode…': 'Cari berdasarkan nama, SKU, atau barcode…',
  'Stock unit': 'Satuan stok',
  'Std cost': 'Biaya std',
  'Failed to load items.': 'Gagal memuat barang.',
  "Couldn't load items": 'Tidak dapat memuat barang',
  'No matching items': 'Tidak ada barang yang cocok',
  'No items yet': 'Belum ada barang',
  'Try adjusting your search or filters.': 'Coba sesuaikan pencarian atau filter Anda.',
  'Add your first item to start building the catalog.': 'Tambahkan barang pertama Anda untuk mulai membangun katalog.',
  'Add a product to your catalog. You can complete suppliers and par levels next.': 'Tambahkan produk ke katalog Anda. Pemasok dan level par dapat dilengkapi setelahnya.',
  'Item created': 'Barang dibuat',
  'Could not create item': 'Tidak dapat membuat barang',
  'Item deleted': 'Barang dihapus',
  'Could not delete item': 'Tidak dapat menghapus barang',
  'Open item': 'Buka barang',
  'Delete item': 'Hapus barang',
  'Delete "{name}"? This also removes its supplier price-list links. This cannot be undone.': 'Hapus "{name}"? Ini juga menghapus tautan daftar harga pemasoknya. Tindakan ini tidak dapat dibatalkan.',
  'Archived': 'Diarsipkan',

  // --- Item form ------------------------------------------------------------
  '— No category —': '— Tanpa kategori —',
  '— No unit —': '— Tanpa satuan —',
  '— None —': '— Tidak ada —',
  'Name is required.': 'Nama wajib diisi.',
  'Must be 0–100.': 'Harus 0–100.',
  'Must be ≥ 0.': 'Harus ≥ 0.',
  'House Red Wine 750ml': 'Anggur Merah House 750ml',
  'SKU / code': 'SKU / kode',
  'Barcode': 'Barcode',
  'Tax / VAT rate (%)': 'Tarif pajak / PPN (%)',
  'Standard cost': 'Biaya standar',
  'Cost currency': 'Mata uang biaya',
  'Default cost centre': 'Pusat biaya default',
  'Pre-fills coding on requisition & PO lines for this item.': 'Mengisi otomatis pengodean pada baris permintaan barang & PO untuk barang ini.',
  'Default GL account': 'Akun GL default',
  'Track stock for this item': 'Lacak stok untuk barang ini',
  "Turn off for services or direct-expense items that aren't held in inventory.": 'Matikan untuk jasa atau barang beban langsung yang tidak disimpan di inventaris.',
  'Tags': 'Tag',
  'beverage, wine, red (comma separated)': 'minuman, anggur, merah (dipisahkan koma)',
  'Optional notes about the item.': 'Catatan opsional tentang barang.',
  'Create item': 'Buat barang',

  // --- Item detail ----------------------------------------------------------
  'Overview': 'Ikhtisar',
  'Suppliers & pricing': 'Pemasok & harga',
  'Purchase history': 'Riwayat pembelian',
  'Par levels': 'Level par',
  'Failed to load item.': 'Gagal memuat barang.',
  "Couldn't load item": 'Tidak dapat memuat barang',
  'Item not found.': 'Barang tidak ditemukan.',
  'Back to catalog': 'Kembali ke katalog',
  'Item sections': 'Bagian barang',
  'Item updated': 'Barang diperbarui',
  'Could not update item': 'Tidak dapat memperbarui barang',
  'Edit item': 'Ubah barang',
  '{count} active': '{count} aktif',
  'Best price': 'Harga terbaik',
  'preferred {price}': 'utama {price}',
  'Price range': 'Rentang harga',
  'Total purchased': 'Total dibeli',
  '{count} purchases': '{count} pembelian',
  'Image': 'Gambar',
  'Image updated': 'Gambar diperbarui',
  'Could not upload image': 'Tidak dapat mengunggah gambar',
  'Image removed': 'Gambar dihapus',
  'Could not remove image': 'Tidak dapat menghapus gambar',
  'Replace': 'Ganti',
  'SKU': 'SKU',
  'Stock tracked': 'Stok dilacak',
  'Tax / VAT rate': 'Tarif pajak / PPN',

  // --- Categories tab -------------------------------------------------------
  '— Top level —': '— Tingkat atas —',
  'Top level': 'Tingkat atas',
  'in {name}': 'di {name}',
  'New category': 'Kategori baru',
  'Edit category': 'Ubah kategori',
  'Delete category': 'Hapus kategori',
  'Create category': 'Buat kategori',
  'Category created': 'Kategori dibuat',
  'Category updated': 'Kategori diperbarui',
  'Category deleted': 'Kategori dihapus',
  'Could not save category': 'Tidak dapat menyimpan kategori',
  'Could not delete category': 'Tidak dapat menghapus kategori',
  'Could not create category': 'Tidak dapat membuat kategori',
  'No categories yet': 'Belum ada kategori',
  'Group items into categories to organise the catalog and reporting.': 'Kelompokkan barang ke dalam kategori untuk merapikan katalog dan pelaporan.',
  'Group items for organisation and reporting. Categories can be nested under a parent.': 'Kelompokkan barang untuk pengorganisasian dan pelaporan. Kategori dapat disarangkan di bawah induk.',
  'Code': 'Kode',
  'Sort order': 'Urutan',
  'Parent category': 'Kategori induk',
  'Delete "{name}"? Items must be reassigned first.': 'Hapus "{name}"? Barang harus dipindahkan terlebih dahulu.',

  // --- Units tab ------------------------------------------------------------
  'New unit': 'Satuan baru',
  'Edit unit': 'Ubah satuan',
  'Delete unit': 'Hapus satuan',
  'Create unit': 'Buat satuan',
  'Unit created': 'Satuan dibuat',
  'Unit updated': 'Satuan diperbarui',
  'Unit deleted': 'Satuan dihapus',
  'Could not save unit': 'Tidak dapat menyimpan satuan',
  'Could not delete unit': 'Tidak dapat menghapus satuan',
  'Could not create unit': 'Tidak dapat membuat satuan',
  'No units yet': 'Belum ada satuan',
  'Define units of measure (e.g. each, kg, case) used for stock and purchasing.': 'Tentukan satuan ukur (mis. pcs, kg, dus) yang digunakan untuk stok dan pembelian.',
  'Units of measure (e.g. each, kg, case) used across stock and purchasing.': 'Satuan ukur (mis. pcs, kg, dus) yang digunakan di seluruh stok dan pembelian.',
  'Base': 'Dasar',
  '×{factor} to base': '×{factor} ke dasar',
  'Count': 'Hitungan',
  'Weight': 'Berat',
  'Volume': 'Volume',
  'Length': 'Panjang',
  'Other': 'Lainnya',
  'Kilogram': 'Kilogram',
  'Dimension': 'Dimensi',
  'Base unit for its dimension': 'Satuan dasar untuk dimensinya',
  'The canonical unit others convert to (factor = 1).': 'Satuan acuan tempat satuan lain dikonversi (faktor = 1).',
  'Factor to base': 'Faktor ke dasar',
  'How many base units equal one of this unit.': 'Berapa banyak satuan dasar yang setara dengan satu satuan ini.',
  'Delete "{name}"? It must not be used by any items.': 'Hapus "{name}"? Satuan ini tidak boleh sedang digunakan oleh barang mana pun.',

  // --- Par levels tab -------------------------------------------------------
  'Par level': 'Level par',
  'Reorder point': 'Titik pemesanan ulang',
  'Reorder qty': 'Kts pesan ulang',
  'Save par levels': 'Simpan level par',
  'Par levels saved': 'Level par tersimpan',
  'Could not save par levels': 'Tidak dapat menyimpan level par',
  'No locations yet': 'Belum ada lokasi',
  'Par levels are set per storage location. Add locations under Settings → Locations first.': 'Level par diatur per lokasi penyimpanan. Tambahkan lokasi di Pengaturan → Lokasi terlebih dahulu.',

  // --- Item suppliers tab ---------------------------------------------------
  'Add supplier': 'Tambah pemasok',
  'Edit supplier price': 'Ubah harga pemasok',
  'Remove supplier': 'Hapus pemasok',
  'Supplier added': 'Pemasok ditambahkan',
  'Supplier updated': 'Pemasok diperbarui',
  'Supplier removed': 'Pemasok dihapus',
  'Could not load suppliers': 'Tidak dapat memuat pemasok',
  'Could not save': 'Tidak dapat menyimpan',
  'Could not remove': 'Tidak dapat menghapus',
  'Preferred': 'Utama',
  'Pack': 'Kemasan',
  'MOQ': 'MOQ',
  'Lead': 'Waktu tunggu',
  'No suppliers linked': 'Belum ada pemasok tertaut',
  'Link suppliers and their prices so this item can be purchased.': 'Tautkan pemasok dan harganya agar barang ini dapat dibeli.',
  "Remove {name} from this item's price list?": 'Hapus {name} dari daftar harga barang ini?',

  // --- Supplier item form ---------------------------------------------------
  '— Select supplier —': '— Pilih pemasok —',
  'Choose a supplier.': 'Pilih pemasok.',
  'Pack size must be greater than 0.': 'Ukuran kemasan harus lebih dari 0.',
  'Supplier SKU': 'SKU pemasok',
  'Vendor reference': 'Referensi vendor',
  'As listed by supplier': 'Sesuai daftar pemasok',
  'Purchase unit': 'Satuan beli',
  'Pack size': 'Ukuran kemasan',
  'Stock units per purchase unit (e.g. 24).': 'Jumlah satuan stok per satuan beli (mis. 24).',
  'Price (per purchase unit)': 'Harga (per satuan beli)',
  'Min. order qty': 'Kts pesan min.',
  'Lead time (days)': 'Waktu tunggu (hari)',
  'Preferred supplier for this item': 'Pemasok utama untuk barang ini',

  // --- Purchase history tab -------------------------------------------------
  'Manual': 'Manual',
  'Purchase order': 'Pesanan pembelian',
  'Could not load purchase history': 'Tidak dapat memuat riwayat pembelian',
  'Enter a quantity greater than 0.': 'Masukkan kuantitas lebih dari 0.',
  'Record purchase': 'Catat pembelian',
  'Purchase recorded': 'Pembelian tercatat',
  'Could not record purchase': 'Tidak dapat mencatat pembelian',
  'Record deleted': 'Catatan dihapus',
  'Could not delete record': 'Tidak dapat menghapus catatan',
  'Delete record': 'Hapus catatan',
  'Delete purchase record': 'Hapus catatan pembelian',
  'Delete the purchase from {date}?': 'Hapus pembelian tanggal {date}?',
  '— No supplier —': '— Tanpa pemasok —',
  '— No location —': '— Tanpa lokasi —',
  'Requested by': 'Diminta oleh',
  'Source': 'Sumber',
  'Purchases': 'Pembelian',
  'Total quantity': 'Total kuantitas',
  'Total spend': 'Total belanja',
  'Avg unit price': 'Harga satuan rata-rata',
  'Last purchase': 'Pembelian terakhir',
  'No purchase history': 'Belum ada riwayat pembelian',
  "Record past purchases manually, or they'll appear here automatically once purchase orders and receiving are live.": 'Catat pembelian lampau secara manual, atau catatan akan muncul di sini otomatis setelah pesanan pembelian dan penerimaan aktif.',
  'Log a historical purchase of this item.': 'Catat pembelian historis barang ini.',
  'PO / invoice number': 'Nomor PO / faktur',
  'Who raised the request': 'Siapa yang mengajukan permintaan',

  // --- Price movements tab --------------------------------------------------
  'Last 30 days': '30 hari terakhir',
  'Last 90 days': '90 hari terakhir',
  'Last 6 months': '6 bulan terakhir',
  'Last 12 months': '12 bulan terakhir',
  'Custom range…': 'Rentang kustom…',
  'All movements': 'Semua pergerakan',
  'Increases only': 'Hanya kenaikan',
  'Decreases only': 'Hanya penurunan',
  'No change': 'Tidak berubah',
  'Failed to load price movements.': 'Gagal memuat pergerakan harga.',
  "Couldn't load price movements": 'Tidak dapat memuat pergerakan harga',
  'First': 'Awal',
  'Latest': 'Terkini',
  'Change': 'Perubahan',
  'Range (min–max)': 'Rentang (min–maks)',
  'Items with movement': 'Barang dengan pergerakan',
  'Price increases': 'Kenaikan harga',
  'went up': 'naik',
  'Price decreases': 'Penurunan harga',
  'came down': 'turun',
  'Biggest mover': 'Pergerakan terbesar',
  'Show': 'Tampilkan',
  'Movement direction': 'Arah pergerakan',
  'No price movements in this period': 'Tidak ada pergerakan harga pada periode ini',
  'Record purchases against your items (Catalog → item → Purchase history) to track how their prices move over time.': 'Catat pembelian pada barang Anda (Katalog → barang → Riwayat pembelian) untuk melacak pergerakan harganya dari waktu ke waktu.',
  'No purchases with prices were recorded in the selected period.': 'Tidak ada pembelian dengan harga yang tercatat pada periode yang dipilih.',

  // --- Recipes list ---------------------------------------------------------
  'Recipes': 'Resep',
  'Recipe': 'Resep',
  'Menu engineering': 'Rekayasa menu',
  'Recipes and menu engineering': 'Resep dan rekayasa menu',
  'Cost recipes and menu items from live ingredient prices, with sub-recipes, yields and food-cost %.': 'Hitung biaya resep dan item menu dari harga bahan terkini, dengan sub-resep, hasil (yield), dan % food cost.',
  'New recipe': 'Resep baru',
  'Search recipes…': 'Cari resep…',
  'Menu item': 'Item menu',
  'Menu items': 'Item menu',
  'Sub-recipe': 'Sub-resep',
  'Sub-recipes': 'Sub-resep',
  'Filter by type': 'Filter berdasarkan tipe',
  'Cost / portion': 'Biaya / porsi',
  'Some ingredients have no cost': 'Beberapa bahan tidak memiliki biaya',
  'Sell': 'Jual',
  'Food cost %': '% food cost',
  'No recipes yet': 'Belum ada resep',
  'Create recipes and menu items to track plate cost and food-cost margin.': 'Buat resep dan item menu untuk melacak biaya per piring dan margin food cost.',

  // --- Recipe form ----------------------------------------------------------
  'Preparation / sub-recipe': 'Persiapan / sub-resep',
  'Could not load recipe': 'Tidak dapat memuat resep',
  'Enter a recipe name.': 'Masukkan nama resep.',
  'Add at least one ingredient with a quantity.': 'Tambahkan minimal satu bahan dengan kuantitas.',
  'Recipe saved': 'Resep tersimpan',
  '{number} created': '{number} dibuat',
  'Could not save recipe': 'Tidak dapat menyimpan resep',
  'Recipe activated': 'Resep diaktifkan',
  'Recipe archived': 'Resep diarsipkan',
  'Recipe set to draft': 'Resep dijadikan draf',
  'Could not change status': 'Tidak dapat mengubah status',
  'Recipe deleted': 'Resep dihapus',
  'Could not delete recipe': 'Tidak dapat menghapus resep',
  'Build a costed ingredient list. Costs roll up from live item prices and nested sub-recipes.': 'Susun daftar bahan berbiaya. Biaya terakumulasi dari harga barang terkini dan sub-resep bersarang.',
  'e.g. Tomato sauce / Margherita pizza': 'mis. Saus tomat / Pizza margherita',
  'Yield qty': 'Kts hasil',
  'Yield unit': 'Satuan hasil',
  'Portions': 'Porsi',
  'Servings the yield produces': 'Jumlah sajian yang dihasilkan',
  'Selling price (per portion)': 'Harga jual (per porsi)',
  'Target food cost %': 'Target % food cost',
  'Flag when over target': 'Tandai saat melebihi target',
  'Method, plating notes (optional)': 'Metode, catatan plating (opsional)',
  'Ingredients': 'Bahan',
  'Add ingredient': 'Tambah bahan',
  'No ingredients yet.': 'Belum ada bahan.',
  'Kind': 'Jenis',
  'Ingredient': 'Bahan',
  'Waste %': '% susut',
  'Cost': 'Biaya',
  'Search items…': 'Cari barang…',
  'Search name or SKU…': 'Cari nama atau SKU…',
  'Searching…': 'Mencari…',
  'No item matches': 'Tidak ada barang yang cocok',
  'No recipe matches': 'Tidak ada resep yang cocok',
  'No cost': 'Tanpa biaya',
  'Cost summary': 'Ringkasan biaya',
  'Total batch cost': 'Total biaya batch',
  'Gross margin / portion': 'Margin kotor / porsi',
  '{percent}% margin': 'margin {percent}%',
  'Some ingredients have no cost or an incompatible unit — total is understated.': 'Beberapa bahan tidak memiliki biaya atau satuannya tidak kompatibel — total lebih rendah dari seharusnya.',
  'Unsaved changes — save to recalculate.': 'Perubahan belum disimpan — simpan untuk menghitung ulang.',
  'Save the recipe to compute its cost.': 'Simpan resep untuk menghitung biayanya.',
  'Save recipe': 'Simpan resep',
  'Create recipe': 'Buat resep',
  'Mark active': 'Tandai aktif',
  'Archive': 'Arsipkan',
  'New menu category': 'Kategori menu baru',
  'Sections like Appetizers, Mains or Desserts. Manage them all under Categories.': 'Bagian seperti Hidangan Pembuka, Utama, atau Penutup. Kelola semuanya di Kategori.',
  'e.g. Appetizers': 'mis. Hidangan Pembuka',
  'New unit of measure': 'Satuan ukur baru',
  'Units are shared across the whole system (stock, purchasing, recipes).': 'Satuan digunakan bersama di seluruh sistem (stok, pembelian, resep).',
  'Delete recipe': 'Hapus resep',
  'This permanently removes the recipe. Recipes used as a sub-recipe elsewhere cannot be deleted.': 'Ini menghapus resep secara permanen. Resep yang digunakan sebagai sub-resep di tempat lain tidak dapat dihapus.',

  // --- Menu engineering list ------------------------------------------------
  'Classify menu items by popularity and profitability (Star / Plowhorse / Puzzle / Dog) using live recipe costs and sales mix.': 'Klasifikasikan item menu berdasarkan popularitas dan profitabilitas (Bintang / Kuda Pekerja / Teka-teki / Anjing) menggunakan biaya resep terkini dan bauran penjualan.',
  'New analysis': 'Analisis baru',
  'Ref': 'Ref',
  'Analysis': 'Analisis',
  'Total contribution': 'Total kontribusi',
  'No analyses yet': 'Belum ada analisis',
  'Build a menu-engineering study from your menu items and the units sold in a period.': 'Susun studi rekayasa menu dari item menu Anda dan jumlah unit terjual dalam suatu periode.',

  // --- Menu analysis form ---------------------------------------------------
  'Could not load analysis': 'Tidak dapat memuat analisis',
  'Enter a name for the analysis.': 'Masukkan nama analisis.',
  'Add at least one menu item.': 'Tambahkan minimal satu item menu.',
  'Analysis saved': 'Analisis tersimpan',
  'Could not save analysis': 'Tidak dapat menyimpan analisis',
  'Analysis deleted': 'Analisis dihapus',
  'Could not delete analysis': 'Tidak dapat menghapus analisis',
  'Menu analysis': 'Analisis menu',
  'New menu analysis': 'Analisis menu baru',
  'Enter units sold per menu item. Margins are computed live from current recipe costs and items are classified into the menu-engineering matrix.': 'Masukkan unit terjual per item menu. Margin dihitung langsung dari biaya resep saat ini dan item diklasifikasikan ke dalam matriks rekayasa menu.',
  'Create analysis': 'Buat analisis',
  'e.g. Dinner menu — Q2': 'mis. Menu makan malam — K2',
  'Period start': 'Awal periode',
  'Period end': 'Akhir periode',
  'Context for this study (optional)': 'Konteks studi ini (opsional)',
  'Menu items & units sold': 'Item menu & unit terjual',
  'Updating…': 'Memperbarui…',
  'Add a menu item…': 'Tambah item menu…',
  'Search menu items…': 'Cari item menu…',
  'No menu items — create some in Recipes first': 'Belum ada item menu — buat dulu di Resep',
  'All menu items added': 'Semua item menu sudah ditambahkan',
  'Add menu item': 'Tambah item menu',
  'Add menu items to begin. Only recipes of type “Menu item” with a selling price can be analysed.': 'Tambahkan item menu untuk memulai. Hanya resep bertipe “Item menu” dengan harga jual yang dapat dianalisis.',
  'Units sold': 'Unit terjual',
  'Mix %': '% bauran',
  'CM': 'MK',
  'Class': 'Kelas',
  'unpriced': 'tanpa harga',
  'over target': 'melebihi target',
  'Menu matrix': 'Matriks menu',
  'Popularity → · Profitability ↑': 'Popularitas → · Profitabilitas ↑',
  'Star': 'Bintang',
  'Plowhorse': 'Kuda Pekerja',
  'Puzzle': 'Teka-teki',
  'Dog': 'Anjing',
  'Stars': 'Bintang',
  'Plowhorses': 'Kuda Pekerja',
  'Puzzles': 'Teka-teki',
  'Dogs': 'Anjing',
  'High popularity · high profit': 'Popularitas tinggi · laba tinggi',
  'High popularity · low profit': 'Popularitas tinggi · laba rendah',
  'Low popularity · high profit': 'Popularitas rendah · laba tinggi',
  'Low popularity · low profit': 'Popularitas rendah · laba rendah',
  'Avg contribution / cover': 'Rata-rata kontribusi / tamu',
  'Profitability threshold': 'Ambang profitabilitas',
  'Avg food cost %': 'Rata-rata % food cost',
  'Popularity threshold': 'Ambang popularitas',
  '70% rule (menu mix)': 'Aturan 70% (bauran menu)',
  '{count} units': '{count} unit',
  'Add menu items with units sold to see the analysis.': 'Tambahkan item menu beserta unit terjual untuk melihat analisis.',
  'Recommendations': 'Rekomendasi',
  'This permanently removes the menu-engineering analysis.': 'Ini menghapus analisis rekayasa menu secara permanen.',
  'Delete analysis': 'Hapus analisis',

  // --- Menu categories ------------------------------------------------------
  'Menu categories': 'Kategori menu',
  'Group recipes and menu items into sections (e.g. Appetizers, Mains, Desserts) used across recipes and menu engineering.': 'Kelompokkan resep dan item menu ke dalam bagian (mis. Hidangan Pembuka, Utama, Penutup) yang digunakan di resep dan rekayasa menu.',
  'Could not load categories': 'Tidak dapat memuat kategori',
  'No menu categories yet': 'Belum ada kategori menu',
  'Group recipes into menu sections (e.g. Appetizers, Mains, Desserts) for organisation and reporting.': 'Kelompokkan resep ke dalam bagian menu (mis. Hidangan Pembuka, Utama, Penutup) untuk pengorganisasian dan pelaporan.',
  'Menu sections used to group recipes and menu items.': 'Bagian menu yang digunakan untuk mengelompokkan resep dan item menu.',
  'Lower numbers appear first': 'Angka lebih kecil tampil lebih dulu',
  'Delete "{name}"? Recipes using it must be reassigned first.': 'Hapus "{name}"? Resep yang menggunakannya harus dipindahkan terlebih dahulu.',
};

export default catalog;
